const REGEX = {
  mobile: /^(\+91[-\s]?)?[0]?(91)?[789]\d{9}$/,
  cronJobExp: /^(?:[^\s]+(?:\s[^\s]+){0,4})$/,
};

export default REGEX;
